/* global pendo */

/**
 * Tracks a custom event using Pendo's tracking API.
 *
 * @param {string} eventName - The name of the event to track.
 * @param {Object} [eventData] - Additional data to associate with the event.
 * @global pendo - The Pendo global object used for tracking events.
 */
export function trackEvent(eventName, eventData) {
  if (typeof pendo === 'undefined') {
    console.warn('Pendo is not defined. Event not tracked:', eventName, eventData);
    return;
  }
  pendo.track(eventName, eventData);
}